import __request__ from "routing/request";
export function displayGettingStarted(requestOptions) {
  return __request__("GET", "/system/gettingstarted", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function dismissGettingStarted(requestOptions) {
  return __request__("POST", "/system/gettingstarted/dismiss", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
